import styled from 'styled-components';
import {MAIN_COLOR} from "../../../components/globalThemes";

export const StyledPageSelectorWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const StyledPageSelectorText = styled.p`
    font-size: 16px;
    font-family: BlenderProBold, serif;
    color: black;
    letter-spacing: 1px;
    padding-top: 15px;
    
    &:before {
        content: "~ ";
        color: #9ec400;
        letter-spacing: 3px;
    }
    
    &:after {
        content: " ~";
        color: #9ec400;
        letter-spacing: 3px;
    }
`;

export const PagesContainer = styled.div`
    display: flex;
    flex-direction: row;
`;

export const StyledPageSelector = styled.p`
    font-size: 17px;
    font-family: BlenderProBold, serif;
    color: ${({active}) => active ? '#9ec400' : 'black'};
    margin: 1px;
    white-space: pre-wrap;
    width: 25px;
    text-align: center;
    cursor: pointer;
    
    &:hover {
        color: ${MAIN_COLOR};
    }
`;

